import navigate from 'utils/navigate'
import { useSnackbar } from '@seasonedsoftware/ui'
import { useSignOut } from 'croods-auth'
import useInstance from 'amplitude/useInstance'
import { useDeleteCredentials } from './cookies'
import useCroodsAuthStorage from './useCroodsAuthStorage'

const handleSignOut = ({
  signOut,
  info,
  amplitudeInstance,
  deleteCredentials,
}) => () => {
  navigate('/sign-in')
  signOut()
  deleteCredentials()
  amplitudeInstance.logEvent('Logout Success')
  amplitudeInstance.setUserId(null)
  info('Logged out successfully')
}

export const useSignOutHandler = () => {
  const { info } = useSnackbar()
  const authStorage = useCroodsAuthStorage()
  const [, signOut] = useSignOut(authStorage)
  const amplitudeInstance = useInstance()
  const deleteCredentials = useDeleteCredentials()

  return handleSignOut({ signOut, info, amplitudeInstance, deleteCredentials })
}

export default handleSignOut
